import { IPm } from 'APIPackage/KnmModule/interfaces/IPm';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';

import { IKnmPmForm } from '../interfaces/IKnmPmForm';

export const convertObjectionWarningFormValuesToKnmData = (
  formAttachments: IKnmPmForm['objectionWarningAttachments'],
  objectionWarningData: IPm['objectionWarning'] | undefined,
): IPm['objectionWarning'] => {
  if (!formAttachments) {
    return null;
  }

  return {
    active: objectionWarningData?.active || null,
    attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(formAttachments),
    correlationToken: objectionWarningData?.correlationToken || null,
    description: objectionWarningData?.description || null,
    guid: objectionWarningData?.guid || null,
    type: objectionWarningData?.type || null,
  };
};
